module.exports = __webpack_public_path__ + "static/condo_ux-4-72b1b428aa985b13d4ec2a032ba048c2.jpg";